import { render, staticRenderFns } from "./GeneralProductStatements.vue?vue&type=template&id=40d037cf&"
import script from "./GeneralProductStatements.vue?vue&type=script&lang=js&"
export * from "./GeneralProductStatements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports